import script from "./PermanentCandidates.root.vue?vue&type=script&setup=true&lang=js"
export * from "./PermanentCandidates.root.vue?vue&type=script&setup=true&lang=js"

import "./PermanentCandidates.root.vue?vue&type=style&index=0&id=c584a5e6&lang=scss"

const __exports__ = script;

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QToolbar,QBtn,QToolbarTitle,QPageContainer,QPage,QFooter,QBanner});
